import { useEffect } from 'react';

import { useCheckoutContext } from '@zooplus/checkout-state';

import PageLoader from '@components/common/page-loader';
import LoginSelectionContainer from '@components/login-selection/login-selection-container';
import {
  CHECKOUT_STATE_PROJECT_ID,
  CUSTOMER_TYPE,
  PAGE_TYPE,
  PAGE_PATH,
} from '@utilities/constants';
import { redirectToUrl } from '@utilities/utils';

const LoginSelection = () => {
  const { isFetching, setPageType, checkoutState } = useCheckoutContext(CHECKOUT_STATE_PROJECT_ID);

  const customerHasActiveSession =
    checkoutState?.stateAttributes?.customerHasActiveSession || false;

  const customerType = checkoutState?.customer?.customerType;

  useEffect(() => {
    setPageType?.(PAGE_TYPE.LOGIN_SELECTION);
  }, [setPageType]);

  useEffect(() => {
    if (customerHasActiveSession) {
      const urlPath =
        customerType === CUSTOMER_TYPE.GUEST_CUSTOMER
          ? PAGE_PATH.GUEST_PREVIEW
          : PAGE_PATH.NEW_PREVIEW;

      redirectToUrl(urlPath);
    }
  }, [customerHasActiveSession, customerType]);

  const pageContentWrapper = window.document.getElementById('pageContentWrapperId');
  if (pageContentWrapper) pageContentWrapper.style.maxWidth = 'unset';

  if (isFetching || customerHasActiveSession) {
    return <PageLoader />;
  }

  return <LoginSelectionContainer />;
};

export default LoginSelection;
